import { Login } from './login';

export function LoginPage() {
  return (
    <Login />
  );
}

export default LoginPage;
